import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { sessionReducer as session } from './session';
import { devicesReducer as devices } from './devices';
import { positionsReducer as positions } from './positions';
import { userDeviceStateReducer as userDeviceState } from './userDeviceState';
import { mapStateTypesReducer as mapStateTypes } from './mapStateTypes';
import { showLoaderStateReducer as showLoaderState } from './showLoader';
import { eventDataReducer as eventData } from './eventData';



const reducer = combineReducers({
  session,
  devices,
  positions,
  userDeviceState,
  mapStateTypes,
  showLoaderState,
  eventData,
});

export { sessionActions } from './session';
export { devicesActions } from './devices';
export { positionsActions } from './positions';
export { userDeviceStateActions } from './userDeviceState';
export { mapStateTypesActions } from './mapStateTypes';
export { showLoaderStateActions } from './showLoader';
export { eventDataActions } from './eventData';




export default configureStore({ reducer });
// showLoader